/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { catalogsPricesCatalogEntryIdGet } from '../fn/catalog-prices/catalogs-prices-catalog-entry-id-get';
import { CatalogsPricesCatalogEntryIdGet$Params } from '../fn/catalog-prices/catalogs-prices-catalog-entry-id-get';
import { catalogsPricesPut } from '../fn/catalog-prices/catalogs-prices-put';
import { CatalogsPricesPut$Params } from '../fn/catalog-prices/catalogs-prices-put';
import { PaginatedPricesResponse } from '../models/paginated-prices-response';
import { PricePutResponses } from '../models/price-put-responses';

@Injectable({ providedIn: 'root' })
export class CatalogPricesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `catalogsPricesPut()` */
  static readonly CatalogsPricesPutPath = '/catalogs/prices';

  /**
   * Replace catalog prices
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `catalogsPricesPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  catalogsPricesPut$Response(params: CatalogsPricesPut$Params, context?: HttpContext): Observable<StrictHttpResponse<PricePutResponses>> {
    return catalogsPricesPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Replace catalog prices
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `catalogsPricesPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  catalogsPricesPut(params: CatalogsPricesPut$Params, context?: HttpContext): Observable<PricePutResponses> {
    return this.catalogsPricesPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<PricePutResponses>): PricePutResponses => r.body)
    );
  }

  /** Path part for operation `catalogsPricesCatalogEntryIdGet()` */
  static readonly CatalogsPricesCatalogEntryIdGetPath = '/catalogs/prices/{catalogEntryId}';

  /**
   * get catalog prices
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `catalogsPricesCatalogEntryIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  catalogsPricesCatalogEntryIdGet$Response(params: CatalogsPricesCatalogEntryIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedPricesResponse>> {
    return catalogsPricesCatalogEntryIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * get catalog prices
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `catalogsPricesCatalogEntryIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  catalogsPricesCatalogEntryIdGet(params: CatalogsPricesCatalogEntryIdGet$Params, context?: HttpContext): Observable<PaginatedPricesResponse> {
    return this.catalogsPricesCatalogEntryIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaginatedPricesResponse>): PaginatedPricesResponse => r.body)
    );
  }

}
